

























import { Component, Vue, Watch } from 'vue-property-decorator';
import ToolChartColor from '@/views/tool/chartcolor/Index.vue';

@Component({
  components: { ToolChartColor },
})
export default class ToolChartColorPicker extends Vue {
  public visible = false;
  public maxHeight = 0;

  public get color() {
    return this.visible ? 'primary' : '';
  }

  public onClose() {
    this.visible = false;
  }

  @Watch('visible')
  public menuChange() {
    this.maxHeight = document.documentElement.clientHeight - 96;
  }
}
